import { variables } from 'shared/styles';

export const appletImageProps = {
  width: '9.2rem',
  height: '9.2rem',
  borderRadius: variables.borderRadius.md,
};
